import * as actionTypes from "../../actions/actionTypes";

const initState = {
  redeems: [],
  fetchRedeemsLoading: false,
  fetchRedeemsError: null,
  actionLoading: false,
  actionMessageSuccess: "",
  actionMessageFailed: "",
};

const redemptionsReducer = (state = initState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_REDEEMS_START:
      return {
        ...state,
        fetchRedeemsLoading: true,
      };
    case actionTypes.FETCH_REDEEMS_SUCCESS:
      return {
        ...state,
        fetchRedeemsLoading: false,
        total: action.total,
        redeems: action.redeems,
      };
    case actionTypes.FETCH_REDEEMS_FAILED:
      return {
        ...state,
        total: 0,
        fetchRedeemsLoading: false,
        fetchRedeemsError: action.error,
      };
    case actionTypes.FILTER_REDEEMS_START:
      return {
        ...state,
        fetchRedeemsLoading: true,
      };
    case actionTypes.FILTER_REDEEMS_SUCCESS:
      return {
        ...state,
        fetchRedeemsLoading: false,
        total: action.total,
        redeems: action.filtered,
      };
    case actionTypes.FILTER_REDEEMS_FAILED:
      return {
        ...state,
        total: 0,
        fetchRedeemsLoading: false,
        fetchRedeemsError: action.error,
      };

    default:
      return state;
  }
};

export default redemptionsReducer;
